import {
LOGING_FAIL, ENTRY_ACTION_ERROR, VENDOR_LOAD_ERROR, EXPENSE_ACCOUNT_LOAD_ERROR
} from '../actions';

const INITIAL_STATE = {
  errMessage: ''
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGING_FAIL:
      return action.errMessage;
    case ENTRY_ACTION_ERROR:
      return action.errMessage;
    case VENDOR_LOAD_ERROR:
      return action.errMessage;
    case EXPENSE_ACCOUNT_LOAD_ERROR:
      return action.errMessage;
    default:
      return INITIAL_STATE;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/errorsReducer.js